import { createVesselContractAPI, getTrackedVesselAPI } from "./api";
import { validateVesselContract, toastError } from "../../../utils";

export const getTrackedVessel = (data) => {
  return new Promise((resolve, reject) => {
    getTrackedVesselAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const createVesselContract = (data) => {
  return new Promise((resolve, reject) => {
    const errorMsg = validateVesselContract(data);
    if (errorMsg) {
      toastError(errorMsg);
      return reject(new Error(errorMsg));
    }
    createVesselContractAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};